import { cloneDeep } from "lodash";

export const handleToggleColHeader = ({ value, onChange, id }) => {
  const { data, colWidthConfig } = value;

  let newData = data.map(row => {
    const newRowData = cloneDeep(row)
    if(newRowData.cellData[0].isRowHeader){ //then remove
      delete newRowData.cellData[0].isRowHeader;
    }else{
      newRowData.cellData[0].isRowHeader = true;
    }
    return newRowData  
  });

  onChange &&
    onChange(id, { data: newData, colWidthConfig });
};
